import styled from "styled-components";
import { truncate } from "styles/utils";

export const Ellipsis = styled.div<{ width?: string }>`
    ${({ width = "99.9%" }) => truncate(width)}
`;
